window.addEventListener("load", function (event) {
  window.setTimeout(function () {
    Highcharts.setOptions({
      global: {
        useUTC: false,
      },
    });

    function getData(numberOfReads = 1) {
      const url = `https://io.ekmpush.com/readMeter/v4/key/MTAxMDoyMDIw/meters/350000900/count/${numberOfReads}/format/json/fields/RMS_Watts_Tot~kWh_Tot/timezone/America~Los_Angeles/`;
      return fetch(url, {
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((response) => {
          const readData = response.readMeter.ReadSet[0].ReadData;
          const finalReads = [];
          let i = 1;
          readData.reverse().forEach((read) => {
            let time = new Date().getTime();
            if (read.Good) {
              finalReads.push([
                read.Time_Stamp_UTC_ms,
                Number(read.RMS_Watts_Tot),
                read.kWh_Tot,
              ]);
              i++;
            }
          });

          return finalReads;
        });
    }

    function getElectricData() {
      const url = `https://summary.ekmmetering.com/summary?client=Widget&meters=300001290&key=MTAxMDoyMDIw&fields=kWh_Tot_Diff&report=dy&format=json&normalize=1&limit=30&timelimit=720&timezone=America~Los_Angeles`;
      return fetch(url, {
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((response) => {
          const readData = response;
          const finalReads = {};
          finalReads.data = [];
          finalReads.dates = [];
          readData.forEach((read) => {
            const date = Highcharts.dateFormat(
              "%e %b",
              read.Start_Time_Stamp_UTC_ms
            );
            finalReads.dates.push(date);
            finalReads.data.push(read.kWh_Tot_Diff);
          });
          finalReads.total = finalReads.data.reduce((a, b) => a + b);
          return finalReads;
        });
    }

    const renderChart = (reads) => {
      Highcharts.chart("chart1", {
        chart: {
          type: "spline",
          marginTop: 30,
          overflow: "visible",
          crop: false,
          animation: Highcharts.svg, // don't animate in old IE
          marginRight: 10,
          events: {
            load: function () {
              let data = [];

              const makeRequest = () => {
                getData().then((response) => {
                  data = [...data, ...response.map((item) => item)];
                });
              };

              makeRequest();
              setInterval(() => makeRequest(), 6000);

              // set up the updating of the chart each second
              const series = this.series[0];
              setInterval(() => {
                const value = data.pop();
                const point = value[1];
                const kWh_Tot = value[2];
                const time = new Date().getTime();
                const totalText = `
                                <div style="display: flex; margin-left: 11%; margin-top: 43px; justify-content: space-between;">
                                <div><b>Total:</b><span style="color: #E1A322"> ${kWh_Tot} kWh</span></div>
                                <div><span style="font-family: Roboto; color: #AAAAAA; font-size: 13px; margin-left: 0%;">
                                Every 5 Seconds<span></div> </div>
                                </div>`;
                series.addPoint([time, point], true, true);
                series.chart.setTitle(null, {
                  text: totalText,
                  align: "middle",
                  useHTML: true,
                  x: 10,
                  y: 250,
                });
              }, 1000);
            },
          },
        },
        title: {
          text: "",
        },
        tooltip: {
          formatter: function () {
            var date = Highcharts.dateFormat("%A, %b %e, %H:%M:%S", this.x);
            var watts = Number(this.y).toLocaleString();
            return `Total Watts: <b>${watts}<br/>
                          <br>${date}<br>Pacific Standard Time`;
          },
        },

        xAxis: {
          type: "datetime",
          tickPixelInterval: 15,
        },
        yAxis: {
          title: {
            text: "Total Watts",
          },
          plotLines: [
            {
              value: 0,
              width: 1,
              color: "#808080",
            },
          ],
        },
        plotOptions: {
          series: {
            marker: {
              enabled: false,
            },
          },
        },
        legend: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        series: [
          {
            name: "Total Watts",
            lineWidth: 0.5,
            color: "#E1A322",
            data: reads,
          },
        ],
      });
    };

    const renderElectricChart = (finalReads) => {
      Highcharts.chart("chart2", {
        chart: {
          type: "column",
          marginTop: 30,
          overflow: "visible",
          crop: false,
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: finalReads.dates.reverse(),
          crosshair: false,
        },
        yAxis: {
          min: 0,
          title: {
            text: "Daily Energy (kWh)",
          },
        },
        tooltip: {
          pointFormat: "kWh Total: <b>{point.y:.1f} kWh</b>",
          formatter: function () {
            let cost = (this.y * 0.18).toFixed(2);
            let day = this.x;
            return `<b>${this.y} kWh</b><br/>Cost: $<b>${cost}</b><br>${day}`;
          },
          shared: true,
          useHTML: true,
        },
        subtitle: {
          text: `<div style="display: flex; margin-left: 10%; margin-top: 40px; justify-content: space-between;">
                      <div><b>Total: </b><span style="color: #E1A322 ">${finalReads.total.toFixed(
                        2
                      )} kWh</span></div>
                       <div><span style="font-family: Roboto; color: #AAAAAA; font-size: 13px; margin-left: 4%">Last 30 Days</div> </div>
                    `,
          align: "middle",
          useHTML: true,
          x: 10,
          y: 250,
        },
        legend: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
            color: "#E1A322",
          },
        },
        series: [
          {
            data: finalReads.data.reverse(),
          },
        ],
      });
    };

    const renderElectricChartMobile = (finalReads) => {
      Highcharts.chart("chart2-mobile", {
        chart: {
          type: "column",
          marginTop: 30,
          overflow: "visible",
          crop: false,
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: finalReads.dates.reverse(),
          crosshair: false,
        },
        yAxis: {
          min: 0,
          title: {
            text: "Daily Energy (kWh)",
          },
        },
        tooltip: {
          pointFormat: "kWh Total: <b>{point.y:.1f} kWh</b>",
          formatter: function () {
            let cost = (this.y * 0.18).toFixed(2);
            let day = this.x;
            return `<b>${this.y} kWh</b><br/>Cost: $<b>${cost}</b><br>${day}`;
          },
          shared: true,
          useHTML: true,
        },
        subtitle: {
          text: `<div style="display: flex; margin-left: 10%; margin-top: 40px; justify-content: space-between;">
                      <div><b>Total: </b><span style="color: #E1A322 ">${finalReads.total.toFixed(
                        2
                      )} kWh</span></div>
                       <div><span style="font-family: Roboto; color: #AAAAAA; font-size: 13px; margin-left: 4%">Last 30 Days</div> </div>
                    `,
          align: "middle",
          useHTML: true,
          x: 10,
          y: 250,
        },
        legend: {
          enabled: false,
        },
        exporting: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0,
            color: "#E1A322",
          },
        },
        series: [
          {
            data: finalReads.data.reverse(),
          },
        ],
      });
    };

    const initialRender = (reads) => {
      renderElectricChart(reads);
      renderElectricChartMobile(reads);
    };

    getData(200).then((reads) => renderChart(reads));
    getElectricData().then((reads) => initialRender(reads));
  }, 4000);
});